// Toggle new data indicator
export default function(el) {

  let row = el.closest('.question-row');
  let cardBody = el.closest('.survey-card-body');
  let userId = cardBody.attr('data-user-id');
  let len = el.val.length;
  if (len > 0) {
    cardBody.attr('data-val-changed', 'true');
    cardBody.find('.user-id').attr('value', userId);
    cardBody.find('.new-data').attr('value', true);
    row.find('.new-data').attr('value', true);
  } else {
    cardBody.attr('data-val-changed', 'false');
    cardBody.find('.user-id').attr('value', '');
    cardBody.find('.new-data').attr('value', true);
    row.find('.new-data').attr('value', false);
  }

}